import { render, staticRenderFns } from "./inactiveUser.vue?vue&type=template&id=6623bd21&scoped=true"
import script from "./inactiveUser.vue?vue&type=script&lang=js"
export * from "./inactiveUser.vue?vue&type=script&lang=js"
import style0 from "./inactiveUser.vue?vue&type=style&index=0&id=6623bd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6623bd21",
  null
  
)

export default component.exports